<template>
    <VJoyHighlight v-if="warnings.length > 0" class="warning" icon="warning-triangle" level="warning" :accent="true" :display-icon="true">
        {{ warnings.join(', ') }}
    </VJoyHighlight>
</template>

<script setup lang="ts">
    import {VJoyHighlight} from '@maltjoy/core-vue';

    defineProps<{
        warnings: string[];
    }>();
</script>
